import { PERMISSIONS } from "@/rbac/permissions.js";
import { ACCESS_LEVELS } from "@/rbac/accessLevels.js";

const { IRGVIEW, IRGEDIT } = PERMISSIONS;

const VIEW_PERMISSIONS = [IRGVIEW];
const EDIT_PERMISSIONS = [IRGEDIT];

export const INSPECTION_REPORT_GENERATOR_PERMISSIONS = {
  [ACCESS_LEVELS.VIEW]: VIEW_PERMISSIONS,
  [ACCESS_LEVELS.EDIT]: EDIT_PERMISSIONS,
};
